import React, { useState ,useEffect} from "react";
import styles from "./mobilenavbar.module.scss";
// import carestreamlogo from "../../assets/carestream-logo-orange.png";
import bluelogo from "../../assets/millensys LOGO dark blue.png";
import whitelogo from "../../assets/millensys LOGO.png";
// import burgerBarBlack from "../../assets/burger-bar.png";
// import burgerBar from "../../assets/ham_white.jpg";
// import { ImMenu } from "react-icons/im";
import { HiOutlineMenu } from "react-icons/hi";
import { Link } from "react-router-dom";
import { FaAngleDown, FaTimes} from "react-icons/fa";
// import { FaAngleDown, FaTimes, FaAngleRight, FaHome } from "react-icons/fa";
import {faStethoscope  ,faBriefcase} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BsStars } from "react-icons/bs";
import {  FaSearch,  } from "react-icons/fa";

import {useNavigate} from "react-router-dom";
import {suggestionFunctionality} from '../../Utility/searchFunctionality'
import { products } from '../../Data/ProductsDetails';

const MobileNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [faqDropdown, setFaqDropdown] = useState(false);
  // const [faqCompanyDropdown, setFaqCompanyDropdown] = useState(false);

  const toggleNavbar = () => {
    setNavbar(!navbar);
    if (faqDropdown) {
      setFaqDropdown(false);
    }
  };

  const toggleFaqDropdown = () => {
    setFaqDropdown(!faqDropdown);
  };

  // const toggleCompanyNavbar = () => {
  //   setNavbar(!navbar);
  //   if (faqCompanyDropdown) {
  //     setFaqCompanyDropdown(false);
  //   }
  // };

  // const toggleCompanyDropdown = () => {
  //   setFaqCompanyDropdown(!faqCompanyDropdown);
  // };
  //--------------
  const [isScrolled, setIsScrolled] = useState(false);

  // Sticky Navbar
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 10;
      setIsScrolled(scrolled);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
    //---------------------------------------
    const navigate = useNavigate();
    const [searchedValue, setSearchedValue] = useState('');
    const [requestedPro, setRequestedPro] = useState([]);
    const [closeSuggestion, setCloseSuggestion] = useState(false);
    const [selected,setSelected] =useState(-1);
    const handleSChange = (event) => {
      setSearchedValue(event.target.value);
    };
    const handleSubmit = (e) => {
      e.preventDefault();
      navigate(`/search?src=${searchedValue}`);
      setSearchedValue('')
    }
  
    const handleKeyDown =(e)=>{
  
        if(e.key === 'ArrowUp' && selected > 0){
          setSelected(prev=>prev - 1);
        }else if(e.key === 'ArrowDown' && selected <(requestedPro.slice(0, 5).length - 1)){
          setSelected(prev=>prev + 1);
        }else if(e.key === 'Enter' && selected >= 0){
          setSearchedValue(requestedPro[selected]);
          setCloseSuggestion(true);
        } 
  
    }
  
  
    useEffect(() => {
      if(!(searchedValue === '')){
          const arr = suggestionFunctionality(products,searchedValue);
          const filtered = [...new Set(arr)]
          setRequestedPro(filtered);
      }else{
        setCloseSuggestion(false);
        setSelected(-1)
        return ;
      }
    },[searchedValue])
  
    //---------------------------------------
  return (
    <section className={`${styles._header_container} ${(isScrolled||navbar ) ? styles.scrolled : ""}`}>
      <div style={{ width: "100%" }}>
        <div className={styles.header_top}>
          {/* Logo  */}
          <Link to='/' className={styles.navlinks_logo_}>
            <img src={(isScrolled||navbar ) ? bluelogo:whitelogo} alt='Millensys-Logo' loading='lazy' />
          </Link>

          {/* Toggle Btns  */}
          <button onClick={toggleNavbar} className={styles.togglebtn}>
            {navbar ? (
              <FaTimes className={styles._toggleicons} style={{color:'#011668', fontSize :"100px", fontWeight : '900'}}/>
            ) : (
              <HiOutlineMenu  className={styles._toggleicons} style={{color:`${isScrolled?'#011668' : '#fff'}`, fontSize :"100px", fontWeight : '900'}}/>
            )}
          </button>
        </div>

        {/* Links dropdown  */}
        <div
          className={`${styles.headerContainer} ${
            navbar ? styles.visible : ""
          }`}
          id='navbar-default'
        >
          <ul className={styles.__header_ullinks}>
            {/* Businesses  */}
            <div>
              <li className={styles.busines_link} onClick={toggleFaqDropdown}>
              Products <FaAngleDown className={styles._header_downarrow} />
              </li>

              {faqDropdown && (
                <div className={styles.business_dropdwon_links}>
                  <Link to='/products' className={styles.category_link}>
                  All Products | <BsStars />
                  {/* All Products | <FontAwesomeIcon icon={faGears} /> */}
                  {/* <FaAngleRight /> */}
                  </Link>
                  <Link to='/products/products_healthcare' className={styles.category_link}>
                  Health-Care Products | <FontAwesomeIcon icon={faStethoscope} /> 
                    {/* <FaAngleRight /> */}
                  </Link>
                  <Link to='/products/products_commercial' className={styles.category_link}>
                  Commercial Products  | <FontAwesomeIcon icon={faBriefcase} />
                  {/* <FaAngleRight /> */}
                  </Link>
                </div>
              )}
            </div>

            {/* Company Dropdown  */}
            <div className={styles.business_dropdwon_links}>
            {/* <div className={styles.__a_list_links}>
            <ul className={styles.__a_list}> */}
                        <Link
                          to='/support'
                          target=''
                          className={styles.category_link}
                        >
                          Support
                        </Link>
                        <Link
                          to='/downloads'
                          target=''
                          className={styles.category_link}
                        >
                          Downloads 
                        </Link>

                        <Link to='/careers' target='' className={styles.category_link}>
                        Careers
                        </Link>
                        <Link
                          to='/about'
                          target=''
                          className={styles.category_link}
                        >
                          About
                        </Link>
                        <Link
                          to='/partner_zone'
                          target=''
                          className={styles.category_link}
                        >
                          Partners
                        </Link>

                      {/* </ul>
            </div> */}
            </div>
            {/* <div className={styles.company_drop_header}>
              <li
                className={styles.busines_link}
                onClick={toggleCompanyDropdown}
              >
                Support 
                <FaAngleDown className={styles._header_downarrow} />
              </li>

              {faqCompanyDropdown && (
                <div className={styles.business_dropdwon_links}>
                  <div className={styles.__a_list_links}>
                    <h5 className={styles.__a_list_header}>Company</h5>
                    <ul className={styles.__a_list}>
                      <li>
                        <Link
                          to='/downloads'
                          target=''
                          className={styles.__a_list_link}
                        >
                          Downloads 
                        </Link>
                      </li>
                      <li>
                        <Link to='/careers' target='' className={styles.__a_list_link}>
                        Careers
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Company History
                        </Link>
                      </li>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          News and Events
                        </Link>
                      </li>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Environmental, Health and Safety
                        </Link>
                      </li> */}
                    {/* </ul>
                  </div> */}

                  {/* <div className={styles.__a_list_links}>
                    <h5 className={styles.__a_list_header}>Support</h5>
                    <ul className={styles.__a_list}>
                      <li>
                        <Link
                          to='/support'
                          target=''
                          className={styles.__a_list_link}
                        >
                          Customer Support
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Worldwide Contacts
                        </Link>
                      </li>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Service and Support
                        </Link>
                      </li>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Submit a Service Request
                        </Link>
                      </li>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Safety Data Sheets
                        </Link>
                      </li> */}
                    {/* </ul>
                  </div> */}

                  {/* <div className={styles.__a_list_links}>
                    <h5 className={styles.__a_list_header}>Logistics</h5>
                    <ul className={styles.__a_list}>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Federal Government Solutions
                        </Link>
                      </li>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Shipping and Routing
                        </Link>
                      </li>
                      <li>
                        <Link to='#' target='' className={styles.__a_list_link}>
                          Worldwide Purchasing
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                {/* </div> */}
              {/* )} */}
            {/* </div> */}

            {/* <li className={styles.m_topnav__item_links}>
              <Link to='/' className={styles.m_topnav__item_link}>
                <FaHome className={styles.m_topnav_homeicon} />
              </Link>
            </li>

            <li className={styles.m_topnav__item_links}>
              <Link
                to='/company'
                title='Company'
                className={styles.m_topnav__item_link}
              >
                Company
              </Link>
            </li>

            <li className={styles.m_topnav__item_links}>
              <Link
                to='#'
                target='_blank'
                className={styles.m_topnav__item_link}
              >
                Careers
              </Link>
            </li>
            <li className={styles.m_topnav__item_links}>
              <Link
                to='/contact'
                title='Contact Us'
                className={styles.m_topnav__item_link}
              >
                Contact Us
              </Link>
            </li> */}
          {/* ===================================== */}
          <section className={styles.search_sec_container} >
            <form className={styles.search_bar_container} onSubmit={handleSubmit}>
              <input type="search" 
                      name="search"
                      className={styles.search_input}
                      placeholder="search products..."
                      autoComplete='off'
                      onChange={handleSChange}
                      value={searchedValue}
                      onKeyDown={handleKeyDown}
              />
              <button type="submit" disabled={searchedValue===''} className={styles.search_button}>
                < FaSearch className={styles.search_icon} />
              </button>
            </form>
            {!(searchedValue ==='') && (requestedPro.length !== 0) && !(closeSuggestion) &&
              <div className={styles.search_suggestion} >
                {requestedPro.slice(0, 5).map((ele,i)=>{
                  return (
                    <button key={i} onClick={()=>{setSearchedValue(ele);setCloseSuggestion(true);}}
                    className={selected === i && styles.activeSuggestion}>
                  {ele.slice(0, 35)}
                </button>
                  )
                })}
              </div>
            } 
          </section>
            {/* ===================================== */}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default MobileNavbar;
